import React from 'react';
import './Faq.scss';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';
// import faq from '../../../constants/faq.constant';

const Faq = () => {
  // const [focus, setFocus] = useState('');

  // const questionRef = useRef<Array<HTMLDivElement | null>>([]);
  // useEffect(() => {
  //   questionRef.current = questionRef.current.slice(0, faq.length);
  // }, [faq]);

  // const faqRef = useRef<Array<HTMLDivElement | null>>([]); // useRef([faq.length].map(() => createRef()));

  // const handleFocus = i => {
  //   // console.log(' questionRef : ', faqRef.current[1].focus());
  //   // faqRef[i].current[i].focus();
  //   faqRef.current[i]!.scrollIntoView();
  // };
  return (
    <div className="faq">
      <Breadcrumbs path={`help/Frequently asked questions`} />
      <div className="wrapper">
        <h1 className="text heading">Not available in this version</h1>
        {/* <div className="first-sidebar">
          <h2>Faq</h2>
          <ul>
            {faq.map((f, i) => (
              <li key={f.id}>
                <a onClick={() => handleFocus(i)}>{f.question}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="content">
          {faq.map((f, i) => (
            <div className="section" key={f.id} ref={el => (faqRef.current[i] = el)}>
              <h2>{f.question}</h2>
              <p dangerouslySetInnerHTML={{ __html: f.answer || '' }} />
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};
export default Faq;
